import { createSlice } from '@reduxjs/toolkit';

interface InitialState {
  env: {
    USERFLOW_TOKEN: string;
  };
}
const initialState: InitialState = {
  env: {
    USERFLOW_TOKEN: '',
  },
};

export const authReducer = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setEnv(state, action) {
      state.env = { ...state.env, ...action.payload };
    },
  },
});

export const { setEnv } = authReducer.actions;
export default authReducer.reducer;
